import Honeybadger from 'honeybadger-js';
import jQuery from 'jquery';
import 'bootstrap';
import 'fonts/index';

window.$ = jQuery;
window.jQuery = jQuery;
window.Honeybadger = Honeybadger;
